export function divideBy3(num, shouldDivideBy3) {
  return shouldDivideBy3 ? Math.floor(num / 3) : num;
}
